import Vue from 'vue';
import fundebug from 'fundebug-javascript';

import { env } from '../libs/env';

// doc 地址 https://docs.fundebug.com/notifier/javascript/framework/vuejs.html
fundebug.apikey = '146f6c3952a67c97aedbded57101c53d075cd171c7e96146a53037d8619cebff';

fundebug.monitorHttpResponse = true;
fundebug.monitorHttpBody = true;
fundebug.breadcrumbSize = 40;

fundebug.metaData = {
  project: 'ssq-peer',
};


// 屏蔽401的错误，因为我们都是401跳转登录
fundebug.filters = [
  {
    res: { status: /^401$/ },
  },
  {
    res: { status: /^0$/ },
  },
  {
    res: { status: /^403$/ },
  },
  {
    res: { status: /^404$/ },
  },
  {
    res: { status: /^405$/ },
  },
  {
    res: { status: /^406$/ },
  },
  {
    message: /onLayoutChanged|RangeError|SyntaxError|Script error|WeixinJSBridge/,
  },
  {
    type: /^unhandledrejection$/,
  },
  {
    target: {
      tagName: /^IMG$/,
    },
  },
  {
    req:
    {
      url: /baidu\.com/,
      method: /^GET$/,
    },
  },
  {
    message: /(ResizeObserver)|(window\.bannerNight)|(kImgMinWidth)|(onLoginStatusChanged)|(hackLocationFailed)|(__gCrWeb)|(_logicalFormForControl)|(PerformanceObserverInit)|(_APP_VIEW_DID_DISAPPEAR)|(changeNetWork)|(KISSY)|(firefox)/, // 都是跟我们系统无关的一些报错，直接屏蔽
  },
  {
    fileName: /chrome-extension/,
  },
  {
    message: /shortcut/,
  },
  {
    type: /^caught$/,
    message: /^cancel$/, // 正常二次确认弹窗取消会触发
  },
];

// 如果地址栏是ip地址或者localhost，就不会报错，但是我们环境上还是域名的，这句话只能对本地有效
fundebug.silentDev = true;

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  const name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
  return (name ? `component <${name}>` : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ` at ${vm.$options && vm.$options.__file}` : '');
}

// env 大于0代表开发或者测试环境，这些环境都不需要监控
(() => {
  if (!env) {
    Vue.config.errorHandler = function (err, vm, info) {
      const componentName = formatComponentName(vm);
      const propsData = vm.$options && vm.$options.propsData;

      fundebug.notifyError(err,
        {
          metaData:
          {
            componentName,
            propsData,
            info,
          },
        });
    };
  } else {
    fundebug.silent = true;
  }
})();



// WEBPACK FOOTER //
// ./src/config/fundebug.config.js